/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDispatch, useSelector } from "react-redux";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { addSchemas, selectSchemasAreLoaded } from "data/store/reducers/schema-model";
import { Logger } from "cms/utils/log/logger";

const useSchemaModel = function () {
    
    const dispatch = useDispatch();
    const { token } = useAuth();
    const hasSchemas = useSelector(selectSchemasAreLoaded);
    
    const fetchSchemaModels = async () => {
        if (!hasSchemas) {
            // console.info(`%c[use-schema-model] Load schema model data`, `color: #27e7f5`)
            Logger.info("[use-schema-model] Load schema model data");
            const schemasResults = await SimpliCityAdminSDK.schemaModel.find(token);
            const schemas = schemasResults.results;
            dispatch(addSchemas(schemas));
        }
    };
    
    return {
        fetchSchemaModels
    };
};

export { useSchemaModel };
